let store = require("../store");
let actions = require("../actions");

let BodyMap = require("../widget/BodyMap");
let DeviceUtil = require("../util/DeviceUtil");
let FormControls = mc.widgets.FormControls;
let FormRange = mc.widgets.FormRange;
let Drop = mc.widgets.Drop;
let Tabs = mc.widgets.Tabs;
let Meter = mc.widgets.Meter;

let SensorConfig = function (props) {
  let onEdit = function (opt, key, val, changed) {
    if (changed) {
      props.onEdit(opt, key, val);
    }
  };

  let deviceConfig = props.deviceConfig;
  let mode = DeviceUtil.getMode(deviceConfig);
  let opts = DeviceUtil.MODES[mode].opts;
  let isPipeline = deviceConfig.pipelineIds !== undefined && deviceConfig.pipelineIds.length > 0;
  let rows = [];

  for (let i in opts) {
    for (let j in opts[i]) {
      let vals = opts[i][j].map(function (v) {
        return {
          value: v,
          label: DeviceUtil.formatValue(j, v)
        };
      });

      let val = deviceConfig.sensorConfig[i][j];
      let key = i + "." + j;

      rows.push(
        <div key={key}>
          <h3>{tx(mode + "." + i + "." + j)}</h3>
          <Tabs
            options={vals}
            value={val}
            role="radiogroup"
            onSelect={onEdit.bind(this, i, j)}/>
        </div>
      );
    }
  }

  if (!isPipeline) {
    return (
    <Drop>
      <div className="rc-sensor-config-handle">
        <a>{DeviceUtil.formatConfig(deviceConfig)}</a>
      </div>
      <div className="mc-drop-content rc-sensor-config-reveal">
        {rows}
      </div>
    </Drop>);
  }
  return (
     <div className="rc-sensor-config-handle-disabled">
        <span>{DeviceUtil.formatConfig(deviceConfig)}</span>
     </div>
  );
};

class DeviceFormView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      deviceConfig: null,
      errors: [],
      submitting: false,
      edited: false
    };
  }

  componentDidMount() {
    this.unsubscribe = store.subscribe(this.handleStoreChange.bind(this));

    let { studyId, deviceConfigId } = this.props;
    let state = store.getState();
    let study = state.study[studyId];
    let mode = state.prefs.designSupervisionMode || "SUPERVISED";

    if (deviceConfigId) {
      if (study) {
        this.handleStoreChange();
      }
      else {
        actions.loadStudy(studyId);
      }
    }
    else {
      this.setState({
        deviceConfig: {
          displayName: "Unnamed",
          durationSec: 3600,
          mode,
          physicalConfig: {
            location: "MEDIAL_CHEST",
            side: "NONE"
          },
          sensorConfig: {
            sensingType: "MPU",
            gyro: {
              mode: "ACCEL",
              periodMs: 32,
              accelRange: 4,
              accelLowPower: true
            }
          },
          studyId
        }
      });
    }
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  handleStoreChange() {
    if (!this.state.deviceConfig) {
      let study = store.getState().study[this.props.studyId];

      if (study) {
        let deviceConfig = study.deviceConfigs.find((dc) => dc.id === this.props.deviceConfigId);

        this.setState({ deviceConfig });
      }
    }
  }

  clickMap(loc) {
    this.setLocation({ target: { value: loc } });
  }

  setLocation(evt) {
    let deviceConfig = mc.utils.clone(this.state.deviceConfig);
    deviceConfig.physicalConfig.location = evt.target.value;

    if (DeviceUtil.SINGULAR_LOCATIONS.includes(deviceConfig.physicalConfig.location)) {
      deviceConfig.physicalConfig.side = "NONE";
    }
    else if (deviceConfig.physicalConfig.side === "NONE") {
      deviceConfig.physicalConfig.side = "ANY";
    }

    this.setState({
      deviceConfig,
      edited: true
    });
  }

  setSide(evt) {
    let deviceConfig = mc.utils.clone(this.state.deviceConfig);
    deviceConfig.physicalConfig.side = evt.target.value;

    this.setState({
      deviceConfig,
      edited: true
    });
  }

  setMode(evt) {
    let deviceConfig = mc.utils.clone(this.state.deviceConfig);
    let mode = DeviceUtil.MODES[evt.target.value];

    deviceConfig.sensorConfig = mc.utils.clone(mode.defaultSensorConfig);
    deviceConfig.physicalConfig.signal = mode.signal;

    this.setState({
      deviceConfig,
      edited: true
    });
  }

  setOpts(opt, key, val) {
    let deviceConfig = mc.utils.clone(this.state.deviceConfig);
    deviceConfig.sensorConfig[opt][key] = val;

    this.setState({
      deviceConfig,
      edited: true
    });
  }

  saveDeviceConfig() {
    let deviceConfig = this.state.deviceConfig;
    let method = deviceConfig.id ? "UPDATE" : "CREATE";

    actions.saveDeviceConfig(deviceConfig, method).then((function (payload) {
      if (payload.errors.length) {
        this.setState({
          errors: payload.errors,
          submitting: false
        });
      }
      else {
        mc.router.trigger("DESIGN_STUDY_VIEW", this.props);
      }
    }).bind(this));

    this.setState({
      submitting: true
    });
  }

  deleteDeviceConfig() {
    let deviceConfig = this.state.deviceConfig;

    mc.ui.alert(tx("delete_config"), {
      level: "warn",
      mode: "confirm",
      labels: {
        confirm: tx("delete"),
        cancel: tx("cancel")
      },
      onHide: (function (confirmed) {
        if (confirmed) {
          actions.saveDeviceConfig(deviceConfig, "DELETE").then((function (payload) {
            if (payload.errors.length) {
              this.setState({
                errors: payload.errors,
                submitting: false
              });
            }
            else {
              mc.router.trigger("DESIGN_STUDY_VIEW", this.props);
            }
          }).bind(this));
        }
      }).bind(this)
    });
  }

  cancel() {
    mc.router.trigger("DESIGN_STUDY_VIEW", this.props);
  }

  showRuntimes() {
    mc.ui.help(`./help/${rc.lang}/runtimes.html`);
  }

  render() {
    let deviceConfig = this.state.deviceConfig;

    if (!deviceConfig) {
      return null;
    }

    let groups = [
      {
        key: "regions",
        locations: DeviceUtil.REGION_LOCATIONS
      },
      {
        key: "muscles",
        locations: DeviceUtil.MUSCLE_LOCATIONS
      },
      {
        key: "cardio",
        locations: DeviceUtil.CARDIO_LOCATIONS
      },
      {
        key: "spine",
        locations: DeviceUtil.SPINE_LOCATIONS
      }
    ];

    let locations = groups.map(function (group) {
      return (
        <optgroup key={group.key} label={tx(group.key)}>
          {
            group.locations.map(function (loc) {
              return <option key={loc} value={loc}>{tx(loc)}</option>;
            })
          }
        </optgroup>
      );
    });

    let sides = (deviceConfig.physicalConfig.side === "NONE" ? ["NONE"] : DeviceUtil.SIDES).map(function (side) {
      return <option key={side} value={side}>{tx("side." + side)}</option>;
    });

    let modes = Object.keys(DeviceUtil.MODES).map(function (mode) {
      return (
        <option key={mode} value={mode}>
          {tx(mode + ".name")}
        </option>
      );
    });

    let loc = deviceConfig.physicalConfig.location;

    let mode = DeviceUtil.getMode(deviceConfig);

    let runtimeHours = DeviceUtil.getRuntimeHours(deviceConfig);

    let isPipeline = deviceConfig.pipelineIds !== undefined && deviceConfig.pipelineIds.length > 0;

    let tooltip = tx("analytics_require_configuration");

    let valid = DeviceUtil.isValidLocation(loc, mode) || isPipeline; // ANTERIOR_THIGH+AFE would complain in the UI otherwise

    return (
      <div className="rc-device-form-view">
        <h1>{tx("edit_sensor") + " (" + tx("mode." + deviceConfig.mode) + ")"}</h1>
        <div>
          <div>
            <div className="mc-form">
            { isPipeline ?
              <div className="mc-form-row" data-tooltip={tooltip}>
                <div className="mc-form-label">{tx("location")}</div>
                <select name="location" onChange={this.setLocation.bind(this)} value={loc} disabled={isPipeline}>
                  {locations}
                </select>
              </div>
            :
              <div className="mc-form-row">
                <div className="mc-form-label">{tx("location")}</div>
                <select name="location" onChange={this.setLocation.bind(this)} value={loc}>
                  {locations}
                </select>
              </div>
            }
              <div className="mc-form-row">
                <div className="mc-form-label">{tx("side")}</div>
                <select name="side" value={deviceConfig.physicalConfig.side} onChange={this.setSide.bind(this)} disabled={sides.length === 1}>
                  {sides}
                </select>
              </div>
            { isPipeline ?
              <div className="mc-form-row" data-tooltip={tooltip}>
                <div className="mc-form-label">{tx("mode")}</div>
                <select name="mode" value={mode} onChange={this.setMode.bind(this)} disabled={isPipeline}>
                  {modes}
                </select>
                <br/>
                <SensorConfig deviceConfig={deviceConfig} onEdit={this.setOpts.bind(this)}/>
              </div>
            :
              <div className="mc-form-row">
                <div className="mc-form-label">{tx("mode")}</div>
                <select name="mode" value={mode} onChange={this.setMode.bind(this)}>
                  {modes}
                </select>
                {!valid && (
                  <img style={{ position: "absolute", margin: "3px" }} src="./img/rc/bang.svg" data-tooltip={tx("error.invalid_location")}/>
                )}
                <br/>
                <SensorConfig deviceConfig={deviceConfig} onEdit={this.setOpts.bind(this)}/>
              </div>
            }
              <div className="mc-form-row">
                <div className="mc-form-label">{"Sensor Runtime"}</div>
                <Meter
                  width={200}
                  height={8}
                  percent={runtimeHours / 145}
                  animate={true}/>
                <br/>
                <a onClick={this.showRuntimes.bind(this)}>
                  {tx("count_hours", { _count: runtimeHours })}
                </a>
              </div>
            </div>
            {isPipeline && (
            <FormControls
              onSave={this.saveDeviceConfig.bind(this)}
              onCancel={this.cancel.bind(this)}/>
            )}
            {!isPipeline && (
            <FormControls
              onSave={this.saveDeviceConfig.bind(this)}
              onCancel={this.cancel.bind(this)}
              onDelete={deviceConfig.id && this.deleteDeviceConfig.bind(this)}/>
            )}
          </div>
          <div className="rc-device-form-view-map">
            <BodyMap selected={loc} disabled={isPipeline} onSelect={this.clickMap.bind(this)}/>
          </div>
        </div>
      </div>
    );
  }
}

module.exports = DeviceFormView;
